import { TicketRepository } from '../repositories/TicketRepository'

export function UpdateSubAreaCase(ticketRepository: TicketRepository) {
  return async function ({ areaId, subAreaId, data }) {
    return await ticketRepository.updateSubArea({ areaId, subAreaId, data })
  }
}
